import i18n from './i18n';

export const unitPreferences = [
  {
    display: i18n.t('formFields:Metric'),
    useImperialUnit: false,
  },
  {
    display: i18n.t('formFields:Imperial'),
    useImperialUnit: true,
  },
];
